// material-ui
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// project import
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';
import NavGroup from './NavGroup';
import { Fragment, useEffect, useMemo, useState } from 'react';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
	const apiMenuItems = useSelector((state) => state.menu.menuItems);
	const drawerOpen = useSelector((state) => state.menu.drawerOpen);
	const openItem = useSelector((state) => state.menu.openItem);
	const [expandedKey, setExpandedKey] = useState(null);

	const sectionGroups = useMemo(
		() => ({
			// 'lyn-process-create': { title: 'Create', selectionVariant: 'dark' },
			'lyn-process-worklist': { title: 'Worklist', selectionVariant: 'dark' },
			'lyn-process-my-cases': { title: 'My Cases', selectionVariant: 'dark' },
			'lyn-process-governance': { title: 'Resources', selectionVariant: 'dark' },
		}),
		[]
	);

	useEffect(() => {
		if (!Array.isArray(apiMenuItems) || apiMenuItems.length === 0) return;

		const openItemValue = openItem?.[0]?.toLowerCase?.();
		const normalizedOpenItem = openItemValue === 'in-progress' ? openItemValue : openItemValue?.replace('/', '')?.replace('-', ' ');

		const matchedParent = apiMenuItems.find((menuItem) =>
			(menuItem?.children ?? []).some((child) => child?.displayName?.toLowerCase?.() === normalizedOpenItem)
		);

		if (matchedParent?.displayName) {
			setExpandedKey(matchedParent.displayName.toLowerCase());
			return;
		}

		if (!openItemValue) {
			const hasWorklistCollapse = apiMenuItems.some(
				(menuItem) => menuItem?.displayName?.toLowerCase?.() === 'worklist' && (menuItem?.children ?? []).length > 0
			);

			if (hasWorklistCollapse) {
				setExpandedKey((prev) => prev ?? 'worklist');
			}
		}
	}, [apiMenuItems, openItem]);

	//=============== temporary comment do not remove this =============

	// if (Object?.keys(menuNotification)?.length === 0 && role?.[0]?.name !== "Lyn-Company-Administrator") {
	//   return (
	//     <Typography variant="span" align="center">
	//       Loading...
	//     </Typography>
	//   );
	// }

	const navGroups = [...(apiMenuItems ?? [])]
		.sort((a, b) => a.serial - b.serial)
		.map((item, index) => {
			const listCode = item?.name ?? '';
			const sectionConfig = sectionGroups[listCode] ?? null;

			const menuType = item.children && item.children.length > 0 ? (sectionConfig ? 'group' : 'collapse') : 'item';
			switch (menuType) {
				case 'group':
					return (
						<NavGroup
							key={item.id}
							item={item}
							index={index}
							level={1}
							accessor="displayName"
							expandedKey={expandedKey}
							setExpandedKey={setExpandedKey}
							sectionConfig={sectionConfig}
						/>
					);
				case 'collapse':
					return (
						<Fragment key={item.id}>
							<NavCollapse item={item} expandedKey={expandedKey} setExpandedKey={setExpandedKey} accessor="displayName" />
						</Fragment>
					);
				case 'item':
					return (
						<Fragment key={item.id}>
							<NavItem item={item} level={1} accessor="displayName" selectionVariant="brand" showIcon />
						</Fragment>
					);
				default:
					return (
						<Typography key={item.id} variant="h6" color="error" align="center">
							Fix - Navigation Group
						</Typography>
					);
			}
		});

	return (
		<Box component="nav" sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '0.875rem' }}>
			{navGroups}
		</Box>
	);
};

export default Navigation;
